import { Component, OnInit } from "@angular/core";
import { FeedbackEventService } from "../../../core/feedback-event.service";
import { UserService } from "../../../core/security/user.service";

@Component({
  selector: "sus-feedback",
  templateUrl: "./sus-feedback.component.html",
  styleUrls: ["./sus-feedback.component.css"],
})
export class SusFeedbackComponent implements OnInit {
  constructor(private feedbackService: FeedbackEventService,private userService: UserService) { }
  flutterState?: any;
  susUsers: { [key: string]: any } = {};
  username:string="";
  public ngOnInit() {
    window["screenName"] = "sus_feedback";
    const user = this.userService.userInfo.emailAddress;
    if(user){
      this.username = user;
    }
  }

  onFlutterAppLoaded(state: any) {
    this.flutterState = state;
    console.log("Flutter app loaded sus");

    this.flutterState.feedbackSubmitted(() => {
      localStorage.setItem(
        "susUser_"+this.username,
        JSON.stringify({ hasSubmitted: true, date: new Date().toISOString() })
      );
    });

    this.flutterState.feedbackClosed(() => {
      this.feedbackService.notifyFeedbackClosed();
    });
  }
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/sus-feedback/sus-feedback.component.ts